module.exports = __webpack_public_path__ + "static/media/24UHCHR21.97341def.jpg";